import { Observable } from 'rxjs/Observable';
import cardUpdateRest, { type CardUpdateRestProps } from '../../rest/card-update';

import 'rxjs/add/observable/fromPromise';

const cardSetService = <T,>({
	fieldId,
	issueKey,
	newValue,
}: CardUpdateRestProps<T>): Observable<null> =>
	Observable.fromPromise(cardUpdateRest({ issueKey, fieldId, newValue }));

export default cardSetService;
